var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"green","size":"30"}},[_vm._v(" mdi-checkbox-marked-circle ")]),_vm._v("It's working! ")],1),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }